import ActionTool from "@core/ActionTool.js";
import {$event_publisher} from "@util/util.js";
import Constant from "@constant/index.js";
import {$crypto} from "@util/util.js";
import API from "@api/index.js";
import { inDebug } from "@/util";

export default class Coupon{
    constructor(){
        this._invalid = false;
        this._coupons = [];
        this._selected = [];
        this._parent = null;
        this._arr = [];
        this._active_status = true
    }

    setParent(parent){
        this._parent = parent;
    }
    
    init(data){
        if(data.length >0 ){
            this._invalid = true;
            this._coupons = data;
        }else{
            this._invalid = false;
        }
    }

    // 设置优惠券凑单商品
    setCouponCheckedCartItem(params){ 
        let _params = {
            shopId: window._shopId,
            terminal: window._terminal,
            cartItemId: params.cartItemId,
            itemId:params.itemId,
            checked:params.checked
        };
        return new Promise((reslove,reject)=>{
            API.setCouponCheckedCartItem(_params).then(x=>{   
                reslove(x)             
            }).catch(err=>{
                reject(`设置优惠券凑单商品:${JSON.stringify(_params)}`)
            })
        })
    }

     // 优惠券立即领取接口
     couponBindForOnce(params){        
        let lenovoId = passport.cookie.lenovoId;
        // let memberCode = passport.cookie.loginName;
        // let _sign=  $crypto.md5(lenovoId + memberCode + params.salesCouponId + ')(*&^%$#@!MNBVCX76543');
        let _sign= $crypto.md5( params.salesCouponId+"_"+lenovoId + ')(*&^%$#@!MNBVCX76543');// $crypto.md5(params.salesCouponId + window._shopId + "10122969834" + "18618386906" + ')(*&^%$#@!MNBVCX76543');

        const WEBSITE_ID_MAP = {
            epp: '10000297',
            lenovo: '10000001',
            biz: '10000331'
          };
        let WEB_SITE_ID = WEBSITE_ID_MAP.lenovo;
        let domain = document.domain;
        if(domain.indexOf('vip') > -1 || domain.indexOf('b.lenovo') > -1 || domain.indexOf('bm.lenovo') > -1){
            domain = 'epp';
        }else if(domain.indexOf('biz') > -1) {
            domain = 'biz';
        } else {
            domain = 'lenovo';
        }
        WEB_SITE_ID = WEBSITE_ID_MAP[domain] || WEBSITE_ID_MAP.lenovo; // 站点ID, epp: 10000297，官网: 10000001
          
        let _params = {
            shopId: window._shopId,
            token: _sign,
            // terminal: window._terminal,
            salesCouponId: params.salesCouponId,
            getTerminal:window._terminal,

            license: 'CART_V1', // 固定，后端确认
            webSiteId: WEB_SITE_ID,
            activityName:params?.goodsCode, // 商品code
        };
        if(inDebug()) {
            console.log('params', _params)
            return;
        }
        return new Promise((reslove,reject)=>{
            API.bindCouponForOnce(_params).then(x=>{   
                reslove()             
            }).catch(err=>{            
                // console.log(JSON.stringify(_params));
                reject(`领取优惠券出错:${err.msg ? err.msg : ""}`)
            })
        })         
    }

    // 获取优惠券列表
    getCouponList(){
        let _params = {
            shopId: window._shopId,
            getTerminal: window._terminal,
            terminal: window._terminal,
            cartItemId: this._parent._itemId
        };
        return new Promise((reslove,reject)=>{
            API.getCouponList(_params).then(x=>{
                reslove(x)             
            }).catch(err=>{
                reject(`获取优惠券列表出错:${JSON.stringify(_params)}`)
            })
        })
    }
    getCheckedCartItem(params){
        let _params = {
            shopId: window._shopId,
            terminal: window._terminal,
            cartItemId: this._parent._itemId,
            ...params
        };
        return new Promise((reslove,reject)=>{
            API.getCouponList(_params).then(x=>{
                reslove(x)             
            }).catch(err=>{
                reject(`获取优惠券列表出错:${JSON.stringify(_params)}`)
            })
        })
    }
    //激活状态
    setActive(params){
        if(this._active_status == false){
            return Promise.reject(Constant.MSG.ACTIVEING);
        }
        this._active_status = false;
        return new Promise((resolve, reject)=>{
            ActionTool.setActiveOne({model:params}).then(data=>{
                //价格变动
                $event_publisher.broadcast(Constant.EVENT_KEY.PRICE, data);
                //重新设置MainSku的属性 + 重新渲染附属商品
                $event_publisher.broadcast(Constant.EVENT_KEY.CHANGE_ALL_ACTIVE, data);
                resolve();
                this._active_status = true;
            }).catch(err=>{
                reject(err);
                this._active_status = true;
            })
        })
    }
    modifyAppList(params){ 
        return new Promise((reslove,reject)=>{
            this._arr = params
            reslove(this._arr)
        })
    }


}